"use client"

import { useQuery } from "@tanstack/react-query"
import {
  getPlatformLowBalanceThresholdAction,
  type PlatformLowBalanceThresholdView,
} from "@/server-actions/platform-low-balance-threshold"

export const platformLowBalanceThresholdQueryKey = ["notifications", "platform-low-balance-threshold"] as const

export function usePlatformLowBalanceThresholdQuery() {
  return useQuery<PlatformLowBalanceThresholdView>({
    queryKey: platformLowBalanceThresholdQueryKey,
    queryFn: async () => {
      const result = await getPlatformLowBalanceThresholdAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
